import React, { useEffect, useMemo, useState } from "react";
import EmptyState from "../../components/common/EmptyState";
import Loader from "../../components/common/Loader";
import BlogCategoryFilter from "../../components/blog/BlogCategoryFilter";
import BlogListGrid from "../../components/blog/BlogList";
import { collectBlogCategories, listBlogs } from "../../services/blogService";
import { setPageMeta } from "../../utils/seo";

const BlogListPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [category, setCategory] = useState("all");
  const [visibleCount, setVisibleCount] = useState(6);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setPageMeta({
      title: "CYNOS Blog | T-Shirt Style, Fabric & Streetwear Guides",
      description: "Read CYNOS guides on styling T-shirts, oversized fits, cotton quality, streetwear, and ecommerce updates.",
    });
    listBlogs()
      .then(setBlogs)
      .finally(() => setLoading(false));
  }, []);

  const categories = useMemo(() => collectBlogCategories(blogs), [blogs]);
  const filteredBlogs = category === "all" ? blogs : blogs.filter((blog) => blog.category === category);
  const visibleBlogs = filteredBlogs.slice(0, visibleCount);

  return (
    <main className="pt-24 px-4 md:px-8 lg:px-12 pb-24" data-testid="blog-page">
      <section className="mb-12">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-cynos-red">CYNOS Journal</span>
        <h1 className="mt-3 font-anton text-6xl md:text-8xl uppercase leading-none">Blog.</h1>
        <p className="mt-5 max-w-2xl text-zinc-400">Style notes, fabric guides, and behind-the-drop stories for people who care how their tees feel and fit.</p>
      </section>

      {loading ? (
        <Loader label="Loading blog..." className="py-20" />
      ) : blogs.length === 0 ? (
        <EmptyState title="No posts yet." message="Fresh CYNOS stories will appear here soon." />
      ) : (
        <>
          <div className="mb-8">
            <BlogCategoryFilter categories={categories} value={category} onChange={(next) => { setCategory(next); setVisibleCount(6); }} />
          </div>
          <BlogListGrid blogs={visibleBlogs} />
          {visibleBlogs.length < filteredBlogs.length && (
            <div className="mt-10 text-center">
              <button onClick={() => setVisibleCount((count) => count + 6)} className="border border-white/20 px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:border-white" data-testid="load-more-blogs">
                Load More
              </button>
            </div>
          )}
        </>
      )}
    </main>
  );
};

export default BlogListPage;
